import { z } from 'zod'

export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 20

export const UsernameSchema = z
	.string({ required_error: "Le nom d'utilisateur est requis" })
	.min(USERNAME_MIN_LENGTH, { message: "Le nom d'utilisateur est trop court" })
	.max(USERNAME_MAX_LENGTH, { message: "Le nom d'utilisateur est trop long" })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message:
			"Le nom d'utilisateur ne peut contenir que des lettres, des chiffres et des tirets bas",
	})
	// users can type the username in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'Le mot de passe est requis' })
	.min(6, { message: 'Le mot de passe est trop court' })
	// NOTE: bcrypt has a limit of 72 bytes (which should be plenty long)
	.refine((val) => new TextEncoder().encode(val).length <= 72, {
		message: 'Le mot de passe est trop long',
	})

export const NameSchema = z
	.string({ required_error: 'Le nom est requis' })
	.min(3, { message: 'Le nom est trop court' })
	.max(40, { message: 'Le nom est trop long' })

export const EmailSchema = z
	.string({ required_error: 'Le courriel est requis' })
	.email({ message: 'Le courriel est invalide' })
	.min(3, { message: 'Le courriel est trop court' })
	.max(100, { message: 'Le courriel est trop long' })
	// users can type the email in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'Les mots de passe ne correspondent pas',
			})
		}
	})
